import { createContext, useState } from 'react';
import { Ark } from '../Services/service';

export interface ArkContext {
    ark: Ark,
    setArk: (ark: Ark) => void,
}

export const DEFAULT_ARK_CONTEXT: ArkContext = {
    ark: {
        sections: [],
        booked: [],
        selected: undefined,
    },
    setArk: () => { },
}

export const useArk = (): ArkContext => {
    const [ark, setArk] = useState<Ark>({
        sections: [],
        booked: [],
        selected: undefined,
    });

    return {
        ark,
        setArk
    };

}

export const arkContext = createContext<ArkContext>(DEFAULT_ARK_CONTEXT);